export default __webpack_public_path__ + "static/media/centro_andes_2_4.3d6143de.JPG";